import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { OPERATIONS_TOTAL_REQUESTS_TREND_SERIES } from "../constants";
import { OperationsMetricChartWidget } from "../OperationsMetricChartWidget";
import type { OperationsTotalRequestsTrendChartData } from "../types";

interface OperationsTotalRequestsTrendWidgetProps {
  chart: OperationsTotalRequestsTrendChartData;
  yAxisMax?: number;
  onExport?: (format: "csv" | "xlsx") => void;
  exportDisabled?: boolean;
  className?: string;
}

export const OperationsTotalRequestsTrendWidget: React.FC<
  OperationsTotalRequestsTrendWidgetProps
> = ({ chart, yAxisMax, onExport, exportDisabled, className }) => {
  const { t } = useTranslation();

  const series = useMemo(
    () =>
      OPERATIONS_TOTAL_REQUESTS_TREND_SERIES.map((item) => ({
        ...item,
        label: t(`analytics.operations.segments.${item.key}`, item.label),
      })),
    [t],
  );

  return (
    <OperationsMetricChartWidget
      title={t("analytics.operations.requestsByDay", "Requests by day")}
      data={chart.data}
      series={series}
      yAxisMax={yAxisMax}
      onExport={onExport}
      exportDisabled={exportDisabled}
      showTooltipTotal
      className={className}
    />
  );
};
